import React from "react";
import { Switch } from "react-router-dom";
import { POSITION_MASTER_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { authorizationService } from "services/common-services/authorization-service";
import PositionMaster from "./PositionMaster/PositionMaster";

function PositionView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={POSITION_MASTER_ROUTE}
        key={POSITION_MASTER_ROUTE}
        component={PositionMaster}
        auth={auth(POSITION_MASTER_ROUTE)}
      />
    </Switch>
  );
}

export { PositionMaster };
export default PositionView;
